<button mat-raised-button color="primary" [routerLink]="['/garantias/nuevo']">
    <mat-icon>add</mat-icon>
    Nueva garantia
</button>
